import { Box, Typography } from "@mui/material";

import {
  getTooltipGraph,
  getTooltipGraphLabel,
  getTooltipGraphPayload,
} from "../../styles";

export interface TooltipEntry {
  name: string;
  /** A series has no value where its source row was null — a forecast that never ran. */
  value?: number | null;
  color: string;
}

const measured = (
  entry: TooltipEntry
): entry is TooltipEntry & { value: number } => typeof entry.value === "number";

/** Shared hover layer for every chart on the page, so they all read the same way. */
const ChartTooltip = ({
  active,
  payload,
  label,
  formatValue,
}: {
  active?: boolean;
  payload?: TooltipEntry[];
  label?: string;
  formatValue: (value: number) => string;
}) => {
  const measurable = payload?.filter(measured) ?? [];
  if (!active || measurable.length === 0) return null;

  return (
    <Box sx={{ ...getTooltipGraph, p: 1 }}>
      {label !== undefined && (
        <Box sx={getTooltipGraphLabel}>
          <Typography variant="caption">{label}</Typography>
        </Box>
      )}
      {measurable.map((entry) => (
        <Box
          key={entry.name}
          sx={{ ...getTooltipGraphPayload, alignItems: "center", gap: 1 }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: entry.color,
              flexShrink: 0,
            }}
          />
          <Typography variant="caption">
            {entry.name} : {formatValue(entry.value)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default ChartTooltip;
